import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, radius, fontSize } = theme.tokens;
  return {
    row: {
      display: "grid",
      gridTemplateColumns: "56px minmax(0, 1fr) auto",
      gap: 14,
      alignItems: "center",
      padding: "12px 0"
    },
    thumb: {
      width: 56,
      height: 56,
      borderRadius: radius.field,
      backgroundColor: color.surface,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden"
    },
    thumbImg: {
      width: "82%",
      height: "82%",
      objectFit: "contain",
      mixBlendMode: "multiply"
    },
    info: {
      display: "flex",
      flexDirection: "column",
      gap: 2,
      minWidth: 0
    },
    name: {
      fontSize: fontSize.body,
      fontWeight: 600,
      color: color.ink,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    meta: {
      fontSize: fontSize.small,
      color: color.muted
    },
    lineTotal: {
      fontSize: fontSize.body,
      fontWeight: 700,
      color: color.ink,
      whiteSpace: "nowrap"
    }
  };
});

export default withCustomStyles;
